import { createContext, useContext } from 'react';

type ConnectionFieldSelectContextValue = {
	isInCreation?: boolean;
	onEditFieldRequested?: () => void;
};

export const ConnectionFieldSelectContext = createContext<ConnectionFieldSelectContextValue>({});
export const useConnectionFieldSelectContext = () => useContext(ConnectionFieldSelectContext);
